export default __webpack_public_path__ + "static/media/rerunSTT.7d2351bc.svg";